export const fbSearchUrl ='https://graph.facebook.com/search';



// WEBPACK FOOTER //
// ./core/urls.js